// src/analytics.js
// Google Analytics integration for React SPA

export const initGoogleAnalytics = () => {
  if (typeof window === 'undefined') return;
  if (window.gtagInitialized) return;

  // Inject gtag.js script
  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://www.googletagmanager.com/gtag/js?id=G-ZSVDQX7207';
  document.head.appendChild(script);

  // Inline gtag config
  window.dataLayer = window.dataLayer || [];
  function gtag(){window.dataLayer.push(arguments);}
  window.gtag = gtag;
  gtag('js', new Date());
  gtag('config', 'G-ZSVDQX7207');
  window.gtagInitialized = true;
};
